import React from 'react'
import styled from '@emotion/styled'
import { Input, Space } from 'antd'
import { PortalArticleSection } from '../../../../models/PortalArtigoModel'
import { createPortalAnchor } from '../../helpers/anchor-utils'
import { createDefaultSection } from '../../helpers/block-defaults'
import { PortalEditorField } from '../PortalEditorField'
import { PortalSectionContentEditor } from './PortalSectionContentEditor'

interface SectionEditorProps {
  value: PortalArticleSection
  isIntro?: boolean
  role?: 'main' | 'subtopic'
  onChange: (section: PortalArticleSection) => void
}

export function SectionEditor({ value, isIntro, role, onChange }: SectionEditorProps) {
  const section = value || createDefaultSection()
  const updateTitle = (title: string) => {
    onChange({
      ...section,
      title,
      anchorId: section.anchorId || createPortalAnchor(title),
    })
  }

  return (
    <Space direction="vertical" style={{ width: '100%' }}>
      <PortalEditorField
        label={isIntro ? 'Título da introdução' : role === 'main' ? 'Título do tópico (H2)' : 'Título do subtópico (H3)'}
      >
        <Input
          value={section.title}
          placeholder={isIntro ? 'Título da introdução' : 'Título da seção'}
          onChange={(event) => updateTitle(event.target.value)}
        />
      </PortalEditorField>
      <PortalEditorField label={isIntro ? 'Linha fina' : 'Subtítulo (opcional)'}>
        <Input
          value={section.subtitle}
          placeholder={isIntro ? 'Linha fina' : 'Subtítulo'}
          onChange={(event) => onChange({ ...section, subtitle: event.target.value })}
        />
      </PortalEditorField>
      <PortalSectionContentEditor
        value={section}
        isIntro={isIntro}
        onChange={onChange}
      />
      <AdvancedFields>
        <summary>Configurações avançadas</summary>
        <Space direction="vertical" style={{ width: '100%' }}>
          <PortalEditorField
            label="Âncora da seção"
            helper="Usada nos links do índice, por exemplo #introducao."
          >
            <Input
              value={section.anchorId}
              placeholder="introducao"
              onChange={(event) => onChange({ ...section, anchorId: event.target.value })}
            />
          </PortalEditorField>
        </Space>
      </AdvancedFields>
    </Space>
  )
}

const AdvancedFields = styled.details`
  width: 100%;
  color: #595959;

  summary {
    cursor: pointer;
    color: #595959;
    font-weight: 600;
    margin-bottom: 8px;
  }
`
